import { APIClient } from '@frontend/api-utils';

export class TransactionSessionClient extends APIClient {
    public static readonly endpoint = '/transaction-api/v1';

    /**
     * API returns a value but this is not relevant for the frontend (yet).
     * @param spotId
     * @param transactionId
     */
    public static async postStartTransactionSession(spotId: string, transactionId: string): Promise<void> {
        await this.post(`${this.endpoint}/spots/${spotId}/transactions/${transactionId}/session`);
    }
}
